import React from 'react'
import Logo from '../../components/Logo/logo';
import loginVector from '../../assets/images/login_signup_left_vector.svg';
import '../Login/login.scss';
import '../SignUp/signup.scss';
import SimpleSlider from '../../components/Slider/Slider';
import SignUpForm from '../SignUp/SignupForm/SignupForm';
import { Link } from 'react-router-dom';

function SignUp() {
    return (
        <div className='login-page signup-page'>
            <div className='login-col login-left-container'>
                <img className='login-vector' src={loginVector} alt="" />
                <SimpleSlider />
            </div>
            <div className='login-col login-right-container signup-right-col'>
                <div className='signup-wrapper'>
                    <Logo />
                    <h1>Sign up with your email</h1>
                    <SignUpForm />
                    <p className='sign-in'>Already have an account? <Link to='/'>Sign In</Link></p>
                </div>
            </div>
        </div>
    )
}

export default SignUp
